<template>
    <div class="x_box A4">
        <div class="x_body">
            <h4 class="text-center" style="font-weight: bold;">{{$t('report_price_list')}}</h4>
            <div class="row">
                <div class="col-sm-12">
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                            <tr>
                                <th>{{$t('no')}}</th>
                                <th>{{$t('code')}}</th>
                                <th>{{$t('name')}}</th>
                                <th>{{$t('brand_list')}}</th>
                                <th style="width: 100px;">{{$t('image')}}</th>
                                <th>{{$t('category')}}</th>
                                <th>{{$t('uom')}}</th>
                                <th>{{$t('weight')}}</th>
                                <th class="text-right">{{ $t('cost') }}</th>
                                <th class="text-right">{{ $t('price_sale') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret,index) in records" :key="index" style="vertical-align: middle;">
                                <td class="text-center">{{index+1}}</td>
                                <td>{{ret.Num}}</td>
                                <td>{{ret.Name}}</td>
                                <td>{{ret.BrandName}}</td>
                                <td>
                                    <template v-if="ret.Image!=null">
                                        <img :src="$base()+ 'image/items/' + ret.Image" style="width: 100px; height: 120px; cursor: pointer;">
                                    </template>
                                </td>
                                <td>{{ret.CategoryName}}</td>
                                <td>{{ret.UomName}}</td>
                                <td>{{ret.Weight}}</td>
                                <td class="text-right">{{$money(ret.Cost)}}</td>
                                <td class="text-right">{{$money(ret.Price)}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function () {
            return {
                query: {
                    CompanyId: this.$store.state.company.Id
                },
                company: {},
                records: []
            };
        },
        created: function () {
            this.getCompany();
            let loading = this.$loading.show();
            let pt = this.$route.query.t;
            if (pt != undefined && pt != null && pt != 0) {
                this.query.CategoryId = pt;
            }
            this.$api().post('report/item/list', this.query).then(res => {
                this.records = res.data.Json.Items;
            }).finally(function () {
                loading.hide();
            });
        },
        methods: {
            getCompany: function () {
                this.$api().post("company").then(res => {
                    if (res.data.Data != null)
                        this.company = res.data.Data;
                });
            }
        }
    };
</script>
<style scoped>
    body {
        font-size: 14px;
    }
</style>